module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.8-108.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.3.8.md
// module id = 524
// module chunks = 297